<template>
  <van-dialog v-model:show="localIsShowDevices" :title="$t('esim_check_supported_devices')" className="w-100"
    confirm-button-text="Ok" :close-on-click-overlay="true">
    <div class="px-4 py-2">
      <van-search v-model="search" :placeholder="$t('esim_enter_model')" class="cs-input-search" @search="onSearch" />
    </div>
    <div class="px-4" v-if="devices">
      <div class="table-responsive" v-if="filteredDevices && filteredDevices.length > 0">
        <table class="table cs-table">
          <tr>
            <th> {{ $t("esim_model") }}</th>
            <th>{{ $t('esim_devices') }}</th>
            <th>{{ $t('esim_version') }}</th>
          </tr>
          <tr v-for="(item, index) in filteredDevices" :key="item.id || index">
            <td>{{ item.model }}</td>
            <td>{{ item.deviceType || item.devices }}</td>
            <td>{{ item.version }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="px-4 py-2" v-if="!devices || !filteredDevices || filteredDevices.length === 0">
      <div class="d-flex flex-column justify-content-center align-items-center" style="min-height: 200px">
        <img src="@/static/search-document.svg" width="48" height="48" class="mb-3" />
        <!-- <van-image width="3rem" height="3rem" fit="contain" src="/static/search-document.svg" class="mb-3" /> -->
        <p class="text-center">
          {{ $t('esim_model_not_available') }}
        </p>
      </div>
    </div>
    <template #footer>
      <div class="d-flex justify-content-center w-100 mb-3 pt-3">
        <van-button class="btn btn-primary btn-ok px-5 shadow-1" @click="handleConfirm">{{ $t("esim_ok") }}</van-button>
      </div>
    </template>
  </van-dialog>
</template>

<script>
import { Button, Col, Row, Search, Image } from "vant";

export default {
  name: "Devices",
  props: {
    isShowDevices: Boolean,
    devices: {
      type: Object,
      required: true,
    },
  },
  components: {
    [Search.name]: Search,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Image.name]: Image,
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    localIsShowDevices: {
      get() {
        return this.isShowDevices;
      },
      set(value) {
        this.$emit("update:isShowDevices", value);
      },
    },
    filteredDevices() {
      const searchValue = (this.search || "").toString().toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "");

      if (!searchValue) return this.devices;

      return this.devices.filter((device) => {
        const model = device.model
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/\s+/g, "");

        return model.includes(searchValue);
      });
    }
  },
  methods: {
    handleConfirm() {
      this.localIsShowDevices = false;
    },
    onSearch(value) {
      this.search = value;
    },
  },
};
</script>

<style>
.cs-table {
  overflow-x: hidden;
}

.cs-table tr th {
  font-size: 12px;
  font-weight: bold;
  padding: 20px 5px 12px 5px;
}

.cs-table tr td {
  font-size: 12px;
  padding: 12px 5px;
}

.cs-input-search .van-field_left-icon>i {
  color: #4A4A4A !important;
}

.cs-input-search .van-field__value input::placeholder {
  color: #545456 !important;
}

.btn-ok {
  width: 97px;
  height: 35px;
  text-transform: uppercase;
  font-size: 15px;
}
</style>
